import { initAccordion } from './modules/accordion';

function initYearFilter() {
  const yearSelects = document.querySelectorAll('.js-year-filter, #achievements-year-filter');
  if (!yearSelects.length) {
    return;
  }

  yearSelects.forEach((select) => {
    select.addEventListener('change', (event) => {
      const targetUrl = event.target.value;
      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAccordion();
  initYearFilter();
});
